import { Box, Button, FlexRow, SingleSelect, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewAttributesStore } from "./CustomViewAttributesStore";

const AttributesActions: FunctionComponent = observer(() => {
	const attributesStore = useCustomViewAttributesStore();
	const {
		containerOptions,
		onChangeSelectedContainer,
		selectedContainer,
	} = attributesStore;

	const { collapseAll, isContainerExpanded } = attributesStore.selectedLevel;

	return (
		<FlexRow
			data-csi-automation="AttributesBrowse"
			gap={1}
		>
			<Box mt={1}>
				<Text res="CustomViewAttributesBrowse" />
			</Box>
			<Box growNoOverflow>
				<SingleSelect
					disableClearable
					fullWidth
					onChange={onChangeSelectedContainer}
					options={containerOptions}
					popperFitContentWidth
					value={selectedContainer}
				/>
			</Box>
			<Box flexShrink="0">
				<Button
					design="link"
					disabled={!isContainerExpanded}
					onClick={collapseAll}
					res="CollapseAll"
				/>
			</Box>
		</FlexRow>
	);
});

export default AttributesActions;